'use client';

import { Menu, MenuButton, MenuDivider, MenuItem } from '@szhsin/react-menu';
import classNames from 'classnames';
import { useNavigate } from 'react-router';
import { MaterialIcons } from '@/common/components/shared/material-icons';
import { useAuthContext } from '@/common/contexts/AuthContext';
import { EmployeeRoleLabels } from '@/common/types';
import { clearStorageKeepingSignInPreferences, removeAuthUserInSession } from '@/common/utils';

export const UserMenu = () => {
  const { authUser, setAuthUser } = useAuthContext();
  const navigate = useNavigate();

  return (
    <Menu
      align="start"
      direction="top"
      menuButton={({ open }) => (
        <MenuButton
          className={classNames(
            'group flex w-full cursor-pointer items-center px-4 py-3 text-xs font-semibold hover:bg-gray-0',
            {
              'bg-gray-0': open,
            },
          )}
        >
          {authUser.pictureUrl ? (
            <img
              alt={authUser.name}
              className="h-6 w-6 rounded-full"
              height={50}
              referrerPolicy="no-referrer"
              src={authUser.pictureUrl}
              width={50}
            />
          ) : (
            <div className="flex h-6 w-6 items-center justify-center rounded-full border bg-gray-0">
              <MaterialIcons iconName="person" fontSize="16px" className="size-4" />
            </div>
          )}

          <span className="ml-2 hidden first-letter:uppercase lg:block">{authUser.name}</span>
        </MenuButton>
      )}
      menuClassName="border-l-0 border-r-0 shadow-dropdown bg-gr rounded-none w-60"
      portal={false}
      shift={5}
      viewScroll="auto"
    >
      <div className="p-4">
        <p className="text-3xs font-normal text-gray-7">{EmployeeRoleLabels[authUser.role]}</p>
        <p className="text-xs font-semibold">{authUser.name}</p>
        <p className="text-main block overflow-hidden overflow-ellipsis whitespace-nowrap text-3xs font-normal">
          {authUser.email}
        </p>
      </div>

      <MenuDivider className="m-0" />

      <MenuItem
        className="m-2 grid grid-cols-[16px_1fr] items-center rounded-sm px-2 py-1 hover:bg-gray-0"
        onClick={() => navigate('/my/detail')}
      >
        <MaterialIcons iconName="person" fill={true} className="text-gray-7" />
        <span className="ml-2 text-xs">My Detail</span>
      </MenuItem>

      <MenuItem
        className="m-2 -mt-2 grid grid-cols-[16px_1fr] items-center rounded-sm px-2 py-1 hover:bg-gray-0"
        onClick={() => navigate('/my/performance-review')}
      >
        <MaterialIcons iconName="star" fill={true} className="text-gray-7" />
        <span className="ml-2 text-xs">My Performance Review</span>
      </MenuItem>

      <MenuItem
        className="m-2 -mt-2 grid grid-cols-[16px_1fr] items-center rounded-sm px-2 py-1 hover:bg-gray-0"
        onClick={() => navigate('/my/mcp-connections')}
      >
        <MaterialIcons iconName="smart_toy" fill={false} className="text-gray-7" />
        <span className="ml-2 text-xs">Connected AI apps</span>
      </MenuItem>

      <MenuDivider className="m-0" />

      <MenuItem
        className="text-main m-2 grid grid-cols-[16px_1fr] items-center rounded-sm px-2 py-1 hover:bg-gray-0"
        onClick={() => {
          setAuthUser(removeAuthUserInSession());
          clearStorageKeepingSignInPreferences();
          navigate('/login');
        }}
      >
        <MaterialIcons iconName="logout" className="text-gray-7" />
        <span className="ml-2 text-xs">Sign Out</span>
      </MenuItem>
      <MenuDivider className="m-0" />
    </Menu>
  );
};
